export const menuItems = [
    {
        id: 100,
        label: "menuitems.menu.text",
        isTitle: true,
        link: "#",
        subItems: [ {
            id: 110, 
            link: "/",
            role:["*"],
            auth:false,
            parentId: 100
        }, {
            id: 110, 
            link: "/userroles",
            hide: true,
            role:["SuperAdmin"],
            auth:false,
            parentId: 100
        }, ]
    }, 
     
    { 
        id: 400,
        label: "menuitems.MezunYonetimi.text",
        icon: "bx bxs-certification",
        link: "#",
        subItems: [
            {
                id: 410,
                label: "menuitems.MezunYonetimi.list.mznmezunlar",
                link: "/mznmezunlar",
                role:["*"],
                auth:true,
                parentId: 300,
            }, 
            {
                id: 410,
                label: "menuitems.MezunYonetimi.list.mznmezunlar",
                link: "/profil",
                role:["*"],
                auth:true,
                parentId: 300,
            }, 
         
            {
                id: 410,
                label: "menuitems.MezunYonetimi.list.mznmezunlar",
                link: "/profiledit",
                role:["*"],
                auth:true,
                parentId: 300,
            }, 
            {
                id: 410,
                label: "menuitems.MezunYonetimi.list.profilzorunlubilgiler",
                link: "/profilzorunlubilgiler",
                role:["*"],
                auth:true,
                parentId: 300,
            }, 
            {
                id: 410,
                label: "menuitems.MezunYonetimi.list.mznmezunlar",
                link: "/maps",
                role:["*"],
                auth:true,
                parentId: 300,
            }, 
            {
                id: 420,
                label: "menuitems.MezunYonetimi.list.ofirma",
                link: "/ofirma",
                role:["*"],
                auth:true,
                parentId: 300,
            }, 
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.mznisilanlari",
                link: "/mznisilanlari",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.mznisilanlarifirma",
                link: "/mznisilanlarifirma",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.addisilani",
                link: "/addisilani",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.mzneposta",
                link: "/mzneposta",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.contactforms",
                link: "/contactforms",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.veritabanlari",
                link: "/veritabanlari",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.veritabanlari",
                link: "/aboneveritabanlari",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.komisyonlar",
                link: "/komisyonlar",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.IdariPersoneller",
                link: "/IdariPersoneller",
                role:["*"],
                auth:true,
                parentId: 300,
            },
            {
                id: 430,
                label: "menuitems.MezunYonetimi.list.AkademikPersoneller",
                link: "/AkademikPersoneller",
                role:["*"],
                auth:true,
                parentId: 300,
            }
            
        ]
    },      
    {
        id: 110, 
        link: "/newsdetail",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },   
    {
        id: 110, 
        link: "/fullnews",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
    {
        id: 110, 
        link: "/fullnotices",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
    {
        id: 110, 
        link: "/dpages",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },  
    {
        id: 110, 
        link: "/fullactivities",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },  
    {
        id: 110, 
        link: "/activitydetails",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    }, 
    {
        id: 110, 
        link: "/logout",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
      
    {
        id: 110, 
        link: "/login",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
    {
        id: 110, 
        link: "/veritabanidetails",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
    {
        id: 110, 
        link: "/aboneveritabanidetails",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
    {
        id: 110, 
        link: "/komisyonpersoneller",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
    {
        id: 110, 
        link: "/fakultekurulu",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    },
    {
        id: 110, 
        link: "/fakulteyonetimkurulu",
        hide: true,
        role:["*"],
        auth:false,
        subItems:[],
        parentId: 100
    }


    


];

